import { render, staticRenderFns } from "./apps.vue?vue&type=template&id=20d3fae2&"
import script from "./apps.vue?vue&type=script&lang=js&"
export * from "./apps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports